import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { mergeMap, Observable, of, timer } from 'rxjs';
import { EboPermissions } from './models/ebo/shared/policies/ebo-permissions.enum';
import { EboRoles } from './models/ebo/shared/policies/ebo-roles.enum';
import { UserExperienceService } from './services/user-experience.service';

@Injectable({ providedIn: 'root' })
export class EboPreloadingStrategy implements PreloadingStrategy {
  activeRole: EboRoles = EboRoles.None; // Default role, can be changed based on user experience
  currentDelay = 0;

  constructor(private uxService: UserExperienceService) {
    this.activeRole = this.uxService.getUserExperience().roles ?? EboRoles.None;
  }

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    const isSafari = /Safari/i.test(navigator.userAgent) && !/Chrome/i.test(navigator.userAgent);
    //console.log(`[OnDemandPreloadStrategy] Checking route: ${navigator.userAgent}, preload: ${isWebkit}`);
    if (isSafari) return of(null); // Safari has issues with preloading, so we disable it for Safari users
    if (route.data && route.data['preload']) {
      const preloadValue = route.data['preload'] as true | EboPermissions | false | undefined;
      if (preloadValue === false || preloadValue === undefined) return of(null);

      if (preloadValue === true || (preloadValue & this.activeRole) > 0) {
        let delay: number = route.data['delay'];
        if (delay === undefined || delay === null) {
          delay = this.currentDelay;
          this.currentDelay += 1000; // Increment delay for each preload
        }
        //console.log('preload called on ' + route.path + ' delay is ' + delay);
        return timer(delay).pipe(
          mergeMap(() => {
            //console.log('Loading now ' + route.path);
            return load();
          })
        );
      }
    }
    //console.log('no preload for the path ' + route.path);
    return of(null);
  }

  //   if (!newExperience.isLoggedIn()) {
  //   this.preloadService.preLoadRole('None', force);
  // } else {
  //   if (newExperience.isSysAdmin()) {
  //     this.preloadService.preLoadRole('SysAdmin', force);
  //   } else if (newExperience.isAdmin()) {
  //     this.preloadService.preLoadRole('Admin', force);
  //   } else if (newExperience.isManager()) {
  //     this.preloadService.preLoadRole('Manager', force);
  //   } else this.preloadService.preLoadRole('Driver', force);
  // }
}
